module.exports = __webpack_public_path__ + "static/media/statsd.19b8c839.png";